/* @flow */

import * as React from 'react';
import { useSelector } from 'react-redux';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import LazyMarketMain from 'src/shared/app/market/component/MarketMain';
import LazyPermissionMain from 'src/shared/app/permission/component/LazyPermissionMain';
import useMembership from 'src/shared/domain/membership/hook/useMembership';
import { isMembershipTermsAccepted } from 'src/shared/domain/membership/util/membershipUtil';

export default function useComponentPreload() {
  const token = useSelector(getAuthenticationToken);
  const membership = useMembership();
  // TODO: replace by `isOptinDone` in `permissionUtils`
  const areTermsAccepted = membership && isMembershipTermsAccepted(membership);

  React.useEffect(() => {
    if (token) {
      LazyMarketMain.preload();
    }
  }, [token]);

  React.useEffect(() => {
    if (!areTermsAccepted) {
      LazyPermissionMain.preload();
    }
  }, [areTermsAccepted]);
}
